import { SupervisionComponentAPI } from "../component classes/supervision-component-api";
import { ComponentAggregation } from "../component classes/component-aggregation";
import { Address } from "../../../components/shared-components/class/component-classes/address";
import { SmartComponentCustomInterface } from "../../../components/shared-components/class/smart-components/smart-component-custom-interface";

export class Supervision {
  public id: number = 0;
  public name: string = "";
  public displayOrder: number = 0;
  public displayOrderMobile: number = 0;
  public refreshAddressTiming: number = 0;
  public componentMobileVisualizationCount: number = Number.MAX_SAFE_INTEGER;
  public showTooltip: boolean = false;
  public showScrollbars: boolean = false;
  public askForPassword: boolean = false;
  public allowJump: boolean = false;
  public allowSound: boolean = false;
  public password: string = "";
  public width: number = 0;
  public height: number = 0;
  public backgroundWidth: number = 0;
  public backgroundHeight: number = 0;
  public idBackgroundImage: number = 0;
  public backgroundImageFormat: string = "";
  public base64BackgroundImage: string = "";
  public updated: boolean = false;
  public base64ScreenShotImage: string = "";
  public backgroundFullScreen: boolean = false;
  public backgroundVersion: number = 0;
  public components: Array<SupervisionComponentAPI> = null;
  public componentsAggregation: Array<ComponentAggregation> = null;
  public adresses: Array<Address> = null;
  public adressesString: Array<string> = null;

  public componentsCount: number = 0;

  public stateAddressesCount: number = 0;

  public invisibleStateAddressesCount: number = 0;

  public invisibleScenariosCount: number = 0;
  public backgroundColor: string = "";
  public defaultResolution: string = "";
  public deviceVisualizationKind: number = 0;
  public isVirtual: boolean = false;
  public enableReturnHome: boolean = false;

  public idEnvironment: number = 0;
  public idSmartComponent: number = 0;

  public automaticAggregation = true;
  public originalName: string = "";
  public listSmartComponent: Array<SmartComponentCustomInterface> = null;

  constructor(supervisionType?: any) {
    if (supervisionType) {
      Object.assign(this, supervisionType);
    }
  }
}
